import { useCallback, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ToastContext } from "./toast-context";
import styles from "./toast.module.css";

interface ToastItem {
	id: number;
	message: string;
	type: "success" | "error";
}

export function ToastProvider({ children }: { children: React.ReactNode }) {
	const [toasts, setToasts] = useState<ToastItem[]>([]);
	const counter = useRef(0);

	const showToast = useCallback((message: string, type: "success" | "error" = "success") => {
		const id = ++counter.current;
		setToasts((prev) => [...prev, { id, message, type }]);
		setTimeout(() => {
			setToasts((prev) => prev.filter((t) => t.id !== id));
		}, 3000);
	}, []);

	return (
		<ToastContext.Provider value={{ showToast }}>
			{children}
			{createPortal(
				<div className={styles.container}>
					{toasts.map((t) => (
						<div key={t.id} className={`${styles.toast} ${styles[t.type]}`}>
							{t.message}
						</div>
					))}
				</div>,
				document.body,
			)}
		</ToastContext.Provider>
	);
}
